import { Component, Input } from '@angular/core';
import { IRepresentative } from '../shared/models/nom-org';
import { IExportSchema } from '../../controls/models/export-to-excel';

@Component({
    selector: 'app-button-export-representatives',
    templateUrl: './button-export-representatives.component.html',
    styleUrl: './button-export-representatives.component.scss',
    standalone: false
})
export class ButtonExportRepresentativesComponent {

  @Input() data: IRepresentative[] = [];
  exportSchema: IExportSchema<IRepresentative>[] = [
    {
      propertyName: 'memberFullName',
      header: 'Name'
    },
    {
      propertyName: 'memberEmail',
      header: 'Email'
    },
    {
      propertyName: 'nationalCommitteeCode',
      header: 'Represented On',
    },
    {
      propertyName: 'membershipType',
      header: 'Role'
    },
    {
      propertyName: 'committeeName',
      header: 'Committee Name'
    },
    {
      propertyName: 'committeeStatus',
      header: 'Committee Status'
    },
    {
      propertyName: 'memberAddress',
      header: 'Member Address'
    },
  ];
}
